import React, { useEffect, useMemo, useState } from "react";
import { I18nextProvider } from "react-i18next";
import { i18n as i18nType } from "i18next";
import { ThemeProvider } from "styled-components";
import { useAppAttributes } from "./hooks/useAppAttributes";
import createI18N from "./i18n";
import { Breakpoint } from "./enums/Breakpoint";
import useMedia from "./hooks/useMedia";
import { I18NNamespace } from "./enums/I18N";
import { themes } from "./themes/themes";
import GlobalStyles from "./components/GlobalStyles";
import SearchWidget from "./components/SearchWidget";
import { MissingLabelsContextProvider } from "./contexts/MissingLabelsContext";
import { initialLabels } from "./i18n/labels";

const App: React.FC = () => {
  const appAttributes = useAppAttributes();
  const isMobile = useMedia(Breakpoint.MaxMobile);
  // i18n
  const [i18n, setI18N] = useState<i18nType | undefined>();

  const activeNamespace = useMemo(() => {
    return isMobile ? I18NNamespace.Mobile : I18NNamespace.General;
  }, [isMobile]);

  useEffect(() => {
    if (appAttributes) {
      if (i18n && !i18n.options.ns?.includes(activeNamespace)) {
        i18n.loadNamespaces(activeNamespace);
      } else {
        createI18N(appAttributes.language.toLowerCase(), activeNamespace).then((i18n) =>
          setI18N(i18n)
        );
      }
    }
  }, [appAttributes, i18n, activeNamespace]);

  const theme = useMemo(() => appAttributes && themes[appAttributes.theme], [appAttributes]);

  return (
    <div id="tix-search-form" className="tix-search-form">
      {i18n && theme && appAttributes && (
        <MissingLabelsContextProvider
          i18n={i18n}
          initLabelsConfig={{
            initialLabels: initialLabels,
            showContentBeforeInitialsAreFetched: false,
          }}
          activeNamespace={activeNamespace}
        >
          <I18nextProvider i18n={i18n}>
            <ThemeProvider theme={theme}>
              <SearchWidget />
              <GlobalStyles layout={appAttributes?.layout} />
            </ThemeProvider>
          </I18nextProvider>
        </MissingLabelsContextProvider>
      )}
    </div>
  );
};

export default App;
